var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.508,
    height: 17.904,
    viewBox: "0 0 21.508 17.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0.6 0.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M14.769,17.539V15.692A3.692,3.692,0,0,0,11.077,12H3.692A3.692,3.692,0,0,0,0,15.692v1.846",
    transform: "translate(0 -0.977)",
    fill: "none",
    stroke: "#ed4928",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 3.712,
    cy: 3.712,
    r: 3.712,
    transform: "translate(3.712 -0.143)",
    fill: "none",
    stroke: "#ed4928",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M21.462,16.626V14.779a3.692,3.692,0,0,0-2.769-3.572M15,.13a3.692,3.692,0,0,1,0,7.154",
    transform: "translate(-1.154 -0.064)",
    fill: "none",
    stroke: "#ed4928",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersfill);
export default __webpack_public_path__ + "static/media/usersfill.b5c3774d4da566c2f4a61045d65b291d.svg";
export { ForwardRef as ReactComponent };